import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%   { box-shadow: inset 0 0 0 6px var(--identify-color); }
  50%  { box-shadow: inset 0 0 0 14px rgba(0,0,0,0); }
  100% { box-shadow: inset 0 0 0 6px var(--identify-color); }
`;

const Frame = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 9999;
  animation: ${pulse} 1000ms ease-in-out infinite;
`;

export default function IdentifyFrame({ color = '#FFD200' }) {
  return (
    <div style={{ position: 'absolute', zIndex: '9999', top: '50%', left: '50%' }}>
      <Frame aria-hidden style={{ '--identify-color': color }} />
    </div>
  );
}
